export type ButtonVariant = 'primary' | 'secondary' | 'ghost';
export type ButtonWidth = 'auto' | 'fixed' | 'full';

export interface ButtonClassNameOptions {
    variant?: ButtonVariant;
    width?: ButtonWidth;
    className?: string;
}

const variantClassNameMap: Record<ButtonVariant, string> = {
    primary: 'btn--primary',
    secondary: 'btn--secondary',
    ghost: 'btn--ghost',
};

const widthClassNameMap: Record<ButtonWidth, string> = {
    auto: '',
    fixed: 'btn--fixed',
    full: 'btn--full',
};

export function buttonClassName({
    variant = 'primary',
    width = 'auto',
    className,
}: ButtonClassNameOptions = {}): string {
    return ['btn', variantClassNameMap[variant], widthClassNameMap[width], className]
        .filter(Boolean)
        .join(' ');
}
